import { Controller } from "@hotwired/stimulus";
import { Toast } from "bootstrap";

export default class extends Controller<HTMLElement> {
  connect() {
    const toast = new Toast(this.element);
    toast.show();

    this.element.addEventListener("hidden.bs.toast", () => {
      toast.dispose();
      this.element.remove();
    });
  }
}
